import classNames from "classnames/bind";
import React, { useEffect } from "react";
import { Skeleton } from "../Skeleton";
import styles from "./Pagination.module.scss";
import { DefaultPageSizeOptions } from "./Pagination.constants";
import type { PageSizeControlsProps } from "./types";

const cx = classNames.bind(styles);

const PageSizeControls = ({
  pageSize,
  total,
  hasNextPage,
  pageSizeText = "",
  onChange,
  isLoading = false,
  isBusy = false,
  pageSizeOptions = DefaultPageSizeOptions,
}: PageSizeControlsProps) => {
  const handleOnChangePageSize = ({
    target: { value: newItemsPerPage },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({
      total,
      page: 1,
      pageSize: Number(newItemsPerPage),
      hasNextPage,
    });
  };

  // reset poge size to next highest size if the current size is out of available range
  useEffect(() => {
    if (!pageSizeOptions.includes(pageSize)) {
      onChange({
        total,
        page: 1,
        pageSize: pageSizeOptions.at(-1) ?? pageSize,
        hasNextPage,
      });
    }
  }, [pageSizeOptions, pageSize, total, hasNextPage]);

  return (
    <Skeleton
      isLoading={isLoading}
      isBusy={isBusy}
    >
      <div className={cx("flex", "tight", "text")}>
        <select
          className={cx("select")}
          value={pageSize}
          onChange={handleOnChangePageSize}
        >
          {/* IMPROVE: items per page should not be constant but just act as clamps */}
          {pageSizeOptions.map((optionValue) => (
            <option key={optionValue}>{optionValue}</option>
          ))}
        </select>
        {pageSizeText ? <>&nbsp;{pageSizeText}</> : null}
      </div>
    </Skeleton>
  );
};

export default PageSizeControls;
